/* RESPONSIBLE TEAM: team-phone */
import PhoneCallCsatRequestSerializer from '../step';

export default PhoneCallCsatRequestSerializer;
